import { useState } from "react";
import { motion } from "framer-motion";
import { Star, PenLine } from "lucide-react";
import SectionHead from "./SectionHead";
import ReviewModal from "@/components/ReviewModal";

const FALLBACK_REVIEWS = [
  {
    name: "Sunita & Prakash Mishra",
    from_place: "Bhubaneswar",
    trip: "Puri – Konark family yatra",
    text: "The driver knew exactly when to reach the temple to avoid the rush. Car was spotless, and the whole trip felt effortless for our parents.",
    rating: 5,
  },
  {
    name: "Rakesh Agarwal",
    from_place: "Visakhapatnam",
    trip: "Corporate airport transfers",
    text: "We use them for every client visit to Rayagada. On time, every single time, and WhatsApp booking makes expense tracking simple.",
    rating: 5,
  },
  {
    name: "The Das Family",
    from_place: "Rayagada",
    trip: "Daringbadi weekend retreat",
    text: "Booked on Friday evening, left Saturday at dawn. The hills were beautiful and the Innova was comfortable for all seven of us.",
    rating: 5,
  },
];

export default function Testimonials({ reviews, packages }) {
  const [modalOpen, setModalOpen] = useState(false);
  const shown = reviews.length > 0 ? reviews : FALLBACK_REVIEWS;

  return (
    <section data-testid="testimonials-section" className="bg-[#0B1014] py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <SectionHead overline="Traveller stories" title="Miles later, they still write to us" />
          <button
            data-testid="review-open-btn"
            onClick={() => setModalOpen(true)}
            className="flex items-center gap-2 rounded-full border border-[#D4AF37]/40 px-5 py-2.5 text-sm text-[#D4AF37] transition-colors hover:bg-[#D4AF37] hover:text-[#0F1418]"
          >
            <PenLine className="h-4 w-4" /> Write a review
          </button>
        </div>
        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {shown.slice(0, 6).map((r, i) => (
            <motion.figure
              key={r.id || r.name}
              data-testid="testimonial-card"
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: (i % 3) * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="gold-glow-hover flex flex-col rounded-2xl border border-white/10 bg-[#171F26] p-8"
            >
              <div className="flex gap-1" aria-label={`${r.rating} star rating`}>
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className={`h-4 w-4 ${s < (r.rating || 5) ? "fill-[#D4AF37] text-[#D4AF37]" : "text-white/20"}`} />
                ))}
              </div>
              <blockquote className="mt-5 flex-1 text-sm leading-relaxed text-white/70">“{r.text}”</blockquote>
              <figcaption className="mt-6 border-t border-white/10 pt-4">
                <p className="font-serif font-semibold">{r.name}</p>
                <p className="mt-0.5 text-xs text-white/45">
                  {[r.from_place, r.trip].filter(Boolean).join(" · ")}
                </p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
      <ReviewModal open={modalOpen} onClose={() => setModalOpen(false)} packages={packages} />
    </section>
  );
}
